<template>
    <navbar position="fixed"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
          <a class="navbar-brand" href="/" style=" -webkit-transition: all 5.5s ease;">
            <div class="logo-container brand">
              <img src="img/chad/chad-ashe-logo.png" alt="chad ashe logo">
            </div>
            Chad Ashe
          </a>
        </template>
        <template slot="navbar-menu" style="padding-top: 20px;">
            <router-link :to="{ path: `/about` }"  @click="" class="nav-item nav-link company-navbar">
                {{ $t('about') }}
            </router-link>
            <a href="#videos" class="nav-item nav-link company-navbar">
              {{ $t('videos') }}
            </a>
            <a href="#interviews" class="nav-item nav-link company-navbar">
              {{ $t('interviews') }}
            </a>
            <a href="#music" class="nav-item nav-link company-navbar">
              {{ $t('music') }}
            </a>
            <a href="#contact" class="nav-item nav-link company-navbar">
              {{ $t('contact') }}
            </a>
        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink} from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    },
    methods: {
      scrollMeTo(refName) {
        debugger
        var element = this.$refs[refName];
        debugger
        element.scrollIntoView();
      }
    }
  }
</script>

<style scoped>

</style>
